//import { LinkText } from 'components/shared/LinkText';
import {
  Heading1,
  Heading2,
  Heading3
} from 'components/shared/Typography.styled';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledHeader,
  StyledHero,
  StyledImageComp,
  StyledIntro,
  StyledLead,
  StyledRights
} from './PrivacyPolicyHero.styled';

const PrivacyPolicyHero: React.FC = () => {
  const { t } = useI18n('privacyPolicy');
  const rights = [
    t('hero.userRights.rights.right1'),
    t('hero.userRights.rights.right2'),
    t('hero.userRights.rights.right3'),
    t('hero.userRights.rights.right4'),
    t('hero.userRights.rights.right5'),
    t('hero.userRights.rights.right6'),
    t('hero.userRights.rights.right7'),
    t('hero.userRights.rights.right8')
  ];
  return (
    <StyledHero>
      <StyledHeader>
        <StyledContainer>
          <div>
            <Heading1>{t('title')}</Heading1>
            <p>{t('subtitle')}</p>
          </div>
          <StyledImageComp>
            <img src={getPublicPath('/images/privacyPolicy/r2.svg')} alt="" />
            <img
              src={getPublicPath('/images/privacyPolicy/luces.svg')}
              alt=""
            />
            <img
              src={getPublicPath('/images/privacyPolicy/holograma.svg')}
              alt=""
            />
          </StyledImageComp>
        </StyledContainer>
      </StyledHeader>
      <StyledContainer>
        <StyledIntro>
          <Heading2 editorial>{t('hero.compromise.title')}</Heading2>
          <p>
            <Trans
              ns={'privacyPolicy'}
              i18nKey={'hero.compromise.desc'}
              components={{
                strong: <strong />
              }}
            ></Trans>
          </p>
        </StyledIntro>
        <StyledIntro>
          <Heading2 editorial>{t('hero.european.title')}</Heading2>
          <StyledLead>{t('hero.european.subtitle')}</StyledLead>
          <p>{t('hero.european.desc')}</p>
        </StyledIntro>
        <StyledRights>
          <Heading3 editorial>{t('hero.userRights.title')}</Heading3>
          <ul>
            {rights.map((r, i) => (
              <li
                key={i}
                dangerouslySetInnerHTML={{
                  __html: r
                }}
              ></li>
            ))}
          </ul>
        </StyledRights>
      </StyledContainer>
    </StyledHero>
  );
};

export default PrivacyPolicyHero;
